import {
    FETCH_USER_SUMMARY_MONTHLY,
    FETCH_USER_SUMMARY_MONTHLY_FETCHING,
    FETCH_USER_SUMMARY_MONTHLY_SUCCESS,
    FETCH_USER_SUMMARY_MONTHLY_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: null,
    userSummaryMonthlyFetching: false,
    userSummaryMonthlyFail: false
};

// ======= Fetching Handlers =======
const fetchUserSummaryMonthlyFetching = (state, action) => {
    return {
        ...state,
        userSummaryMonthlyFetching: true,
        userSummaryMonthlyFail: false
    };
};

const fetchUserSummaryMonthlySuccess = (state, action) => {
    return {
        data: {
            ...action.data
        },
        userSummaryMonthlyFetching: false,
        userSummaryMonthlyFail: false
    };
};

const fetchUserSummaryMonthlyFail = (state, action) => {
    return {
        data: {
            ...state.data
        },
        userSummaryMonthlyFetching: false,
        userSummaryMonthlyFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_USER_SUMMARY_MONTHLY_FETCHING]: fetchUserSummaryMonthlyFetching,
    [FETCH_USER_SUMMARY_MONTHLY_SUCCESS]: fetchUserSummaryMonthlySuccess,
    [FETCH_USER_SUMMARY_MONTHLY_FAIL]: fetchUserSummaryMonthlyFail
};

// ======= Default Action ======
export default function userSummaryMonthly(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchUserSummaryMonthly(displayName, startDate, endDate, evictCache) {
    return {
        type: FETCH_USER_SUMMARY_MONTHLY,
        displayName: displayName,
        startDate: startDate,
        endDate: endDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getUserSummaryMonthlyData = (state) => {
    if (state.userSummaryMonthly) {
        return state.userSummaryMonthly.data; // figure out why this is undefined?
    } else {
        return null;
    }
};

export const isUserSummaryMonthlyFetching = (state) => {
    return state.userSummaryMonthly.userSummaryMonthlyFetching;
};

export const didUserSummaryMonthlyFail = (state) => {
    return state.userSummaryMonthly.userSummaryMonthlyFail;
};
